module.exports = __webpack_public_path__ + "img/pork.e416a511.svg";